import actionTypes from "../../actions/actionTypes";

const _initState = {
  isLoading: false,
  data: {},
};

const uloha = (state = _initState, action) => {
  switch (action.type) {
    case actionTypes.CHANGE_ULOHA:
      return { ...state, data: { ...action.data } };

    default:
      return state;
  }
};

export default uloha;
